import { Button, Col, Container, FormGroup, Input, Label, Row, Select, Textarea } from "@/components";
import { TInput } from "@/components/forms/form-elements/types";
import { FlexWrapper } from "@/components/layout/flex/flexWrapper";
import { useAxios } from "@/context/axiosContext";
import { useDialog } from "@/context/dialogContext";
import { useRedis } from "@/hooks/useRedis";
import commonUtils from "@/utils/commonUtils";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import '@toast-ui/editor/dist/toastui-editor-viewer.css'

import { Viewer } from '@toast-ui/react-editor'

interface DataRow {
  cmpnyCd: string
  nttSn: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  cstId: string
  userId: string
  bbsSj: string
  prmtType: string
  prmtTypeNm: string
  bizCd: string
  bizNm: string
  nttSj: string
  nttCn: string
  prmtStartDate: string
  prmtEndDate: string
  prmtUrl: string
  // thumbnailSeq: string
  // thumbnailFileNm: string
  readngCnt: string
  adminDelYn: string
  adminDelYnNm: string
  tpPrmtYn: string
  popupYn: string
  useYn: string
  useYnNm: string
  delYn: string
  delYnNm: string
}

const DetailComPrmt: React.FC = () => {
  const axios = useAxios();
  const navigate = useNavigate();
  const location = useLocation();

  const { getComCodes, getComCodeValue } = useRedis();

  const { showAlert, showConfirm } = useDialog();
  const [data, setData] = useState<DataRow>({
    cmpnyCd: '',
    nttSn: '',
    regId: '',
    regDate: '',
    updId: '',
    updDate: '',
    cstId: '',
    userId: '',
    bbsSj: '',
    prmtType: '',
    prmtTypeNm: '',
    bizCd: '',
    bizNm: '',
    nttSj: '',
    nttCn: '',
    prmtStartDate: '',
    prmtEndDate: '',
    prmtUrl: '',
    // thumbnailSeq: '',
    // thumbnailFileNm: '',
    readngCnt: '',
    adminDelYn: 'N',
    adminDelYnNm: '',
    tpPrmtYn: 'N',
    popupYn: 'N',
    useYn: '',
    useYnNm: '',
    delYn: '',
    delYnNm: '',
  });

  const handleInputChange = (e: React.ChangeEvent<TInput>) => {
    const name = e.target.name;
    const value = e.target.value;

    setData((prevState) => {
      return { ...prevState, [name]: value };
    });
  }

  const updatePrmt = async () => {

    const response: any = await axios.post('/prmt/update', data,);
    if (response.status === 200 && !response.data.common.resultCode) {
      // TODO 성공코드값
      navigate('/prmt');
    } else {
      showAlert({
        title: response.data.common.resultMsg,
      })
    }
  };

  const getPrmt = async () => {
    const response: any = await axios.post('/prmt/detail', { nttSn: location.state.nttSn },);
    if (response.status === 200 && !response.data.common.resultCode) {
      const prmt = response.data.data.prmt;
      // data.prmtStartDate = data.prmtStartDate?.split(" ")[0].replace(/-/g, "");
      // data.prmtEndDate = data.prmtEndDate?.split(" ")[0].replace(/-/g, "");
      setData(prmt);

    } else {
      showAlert({
        title: '잘못된 접근입니다.',
        onClose() {
          navigate('/prmt', { state: { search: location.state?.search || '', } })
        }
      })
    }

  }

  useEffect(() => {
    getPrmt();
  }, []);

  return (
    <>
      <div style={{ width: '100%', height: '100%', marginTop: '50px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <p style={{ fontSize: '20px' }}>이벤트 관리</p>
          <FlexWrapper gap="20px">
            <Button
              onClick={() =>{
                navigate('/prmt', { state: { searchData: location.state?.searchData || '', } })
              }
                // showConfirm({
                //   title: '이벤트목록 화면으로 이동할까요?',
                //   onConfirm() {
                  //   },
                  // })
              }
              color="neverbe"
              variant="outlined"
            >
              목록
            </Button>
            <Button
              onClick={() =>
                showConfirm({
                  title: '이벤트를 수정할까요?',
                  onConfirm() {
                    updatePrmt();
                  },
                })
              }
              color="neverbe"
            >
              저장
            </Button>
          </FlexWrapper>
        </div>
      </div>
      <div>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="nttSn">
                이벤트번호
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="nttSn"
                name="nttSn"
                type="text"
                maxLength={255}
                value={data.nttSn}
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="userId">
                작성자
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="userId"
                name="userId"
                type="text"
                maxLength={255}
                value={data.userId}
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="readngCnt">
                조회수
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="readngCnt"
                name="readngCnt"
                type="text"
                maxLength={255}
                value={data.readngCnt.toLocaleString()}
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="nttSj">
                이벤트제목
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="nttSj"
                name="nttSj"
                type="text"
                maxLength={255}
                value={data.nttSj}
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="prmtUrl">
                이벤트URL
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="prmtUrl"
                name="prmtUrl"
                type="text"
                maxLength={255}
                value={data.prmtUrl}
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="nttCn">
                이벤트내용
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <div
                style={{
                  marginBottom: '10px',
                  border: '1px solid',
                  borderRadius: '4px',
                  padding: '10px',
                }}
              >
                <Viewer key={data.nttSn} initialValue={data.nttCn} />
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={2}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="prmtType">
                프로모션구분
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="prmtType"
                name="prmtType"
                type="text"
                value={getComCodeValue("PRMT_TYPE", data.prmtType)?.codeNm || data.prmtType}
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="bizNm">
              골프장명
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="bizNm"
                name="bizNm"
                type="text"
                value={data.bizNm}
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="prmtStartDate">
                이벤트시작일
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="prmtStartDate"
                name="prmtStartDate"
                type="text"
                value={commonUtils.dateStrChgFomat(data.prmtStartDate, 'yyyy.MM.dd')}
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="prmtEndDate">
              이벤트종료일
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="prmtEndDate"
                name="prmtEndDate"
                type="text"
                value={commonUtils.dateStrChgFomat(data.prmtEndDate, 'yyyy.MM.dd')}
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="useYn">
                사용여부
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="useYn"
                name="useYn"
                type="text"
                value={data.useYnNm || data.useYn}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="delYn">
                삭제여부
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="delYn"
                name="delYn"
                type="text"
                value={data.delYnNm || data.delYn}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="adminDelYn">
                어드민삭제여부
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Select
                id="adminDelYn"
                name="adminDelYn"
                value={data.adminDelYn}
                onChange={handleInputChange}
              >
                {getComCodes('DEL_YN').map((item) => (
                  <option key={'adminDelYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="tpPrmtYn">
                상단고정여부
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Select
                id="tpPrmtYn"
                name="tpPrmtYn"
                value={data.tpPrmtYn}
                onChange={handleInputChange}
              >
                {getComCodes('TP_NOTICE_YN').map((item) => (
                  <option key={'tpPrmtYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="popupYn">
                팝업여부
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Select
                id="popupYn"
                name="popupYn"
                value={data.popupYn}
                onChange={handleInputChange}
              >
                {getComCodes('POPUP_YN').map((item) => (
                  <option key={'popupYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
        </Row>
        {/* <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="thumbnailFileNm">
                썸네일파일명
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="thumbnailFileNm"
                name="thumbnailFileNm"
                type="text"
                maxLength={255}
                value={data.thumbnailFileNm}
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row> */}
        <Row>
          <Col md={3}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor={`regId`}>
                등록자
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id={`regId`}
                name={`regId`}
                type="text"
                value={data .regId}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor={`regDate`}>
                등록일시
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id={`regDate`}
                name={`regDate`}
                value={commonUtils.formatDate(data.regDate, true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor={`updId`}>
                수정자
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id={`updId`}
                name={`updId`}
                type="text"
                value={data.updId}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor={`updDate`}>
                수정일시
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id={`updDate`}
                name={`updDate`}
                value={commonUtils.formatDate(data.updDate, true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DetailComPrmt;